import { createSlice } from '@reduxjs/toolkit';
import { fetchStockDataThunk, fetchWatchlistSimpleChartsThunk } from './stockDataActions';
import { extractErrorMessage } from '../../../utils/errorMessages';

const stockSlice = createSlice({
  name: 'stock',
  initialState: {
    data: [],
    indicators: {},
    loading: false,
    error: null,

    currentSymbol: '',
    currentTimeFrame: '1D',
    currentIndicators: [],

    watchlistSimpleCharts: {},
    watchlistSimpleLoading: false,
    watchlistSimpleError: null,
  },

  reducers: {
    setCurrentSymbol: (state, action) => {
      state.currentSymbol = action.payload;
    },
    setCurrentTimeFrame: (state, action) => {
      state.currentTimeFrame = action.payload;
    },
    setCurrentIndicators: (state, action) => {
      state.currentIndicators = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      // === Main Chart Fetch ===
      .addCase(fetchStockDataThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockDataThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchStockDataThunk.rejected, (state, action) => {
        state.loading = false;
        // Was the raw action.payload -- this app's error envelope is
        // `{error:{message}}`, not a string, so chartMain/chart.jsx's
        // `error.detail || error.message` render always fell through to
        // its hardcoded "Unknown error" fallback. Same fix pattern as
        // marketSnapshotSlice.js.
        state.error = extractErrorMessage(action.payload, action.error?.message);
      })

      // === Watchlist Sparklines ===
      .addCase(fetchWatchlistSimpleChartsThunk.pending, (state) => {
        state.watchlistSimpleLoading = true;
        state.watchlistSimpleError = null;
      })
      .addCase(fetchWatchlistSimpleChartsThunk.fulfilled, (state, action) => {
        state.watchlistSimpleLoading = false;
        state.watchlistSimpleCharts = {
          ...state.watchlistSimpleCharts,
          ...action.payload,
        };
      })
      .addCase(fetchWatchlistSimpleChartsThunk.rejected, (state, action) => {
        state.watchlistSimpleLoading = false;
        state.watchlistSimpleError = extractErrorMessage(action.payload, action.error?.message);
      });
  },
});

export const {
  setCurrentSymbol,
  setCurrentTimeFrame,
  setCurrentIndicators,
} = stockSlice.actions;

export default stockSlice.reducer;
